"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgEdit01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.293 2.293a3.828 3.828 0 1 1 5.414 5.414L8.501 20.913l-.05.05c-.245.246-.461.462-.718.631-.225.149-.47.267-.727.35-.293.095-.597.128-.941.166l-.07.008-3.385.376a1 1 0 0 1-1.104-1.104l.376-3.385.008-.07c.038-.344.071-.648.166-.94a3 3 0 0 1 .35-.728c.169-.257.385-.473.63-.718l.05-.05L16.294 2.293Z", fill: "currentColor" }) }))); };
exports.default = SvgEdit01;
